module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/babel-runtime/core-js/object/define-properties.js
// module id = 387
// module chunks = 0